import { createAsyncThunk } from "@reduxjs/toolkit";
import { endPoints } from "../../../configs/apiUrls";
import { apiGet, buildQuery } from "../../../services/apiServices";

export const fetchAgentInteractions = createAsyncThunk(
  "agentInteractions/fetchList",
  async (filters: any, { rejectWithValue }) => {
    try {
      const queryString = buildQuery(filters);
      const response: any = await apiGet(`${endPoints.GET_AGENT_INTERACTIONS}?${queryString}`);
      
      if (response.success) {
        return {
          data: response.data,
          total: response.total,
        };
      }
      return rejectWithValue("Failed to fetch interactions");
    } catch (error: any) {
      return rejectWithValue(error.message || "Something went wrong");
    }
  }
);